import React, { useEffect, useState } from 'react'
import ContractList from './components/ContractList/ContractList'
import Simulation from './components/Simulation/Simulation'
import CustomerData from './components/CustomerData/CustomerData'
import RefinancingData from './components/RefinancingData/RefinancingData'
import AddressData from './components/AddressData/AddressData'
import { IFinishedProposalsToRefinance, IRefinancingClient } from './refinancingInterfaces'
import { useDispatch } from 'react-redux'
import { simulationSteps } from 'store/modules/simulation/actions'
import { useSimulation } from 'hooks'
import SimulatorSteps from '../Simulator/components/SimulatorSteps/SimulatorSteps'

function PageContainer ({ children }: { children: React.ReactNode }) {
  return (
    <div className='position-relative flex flex-justify-center flex-align-center'>
      <div className='refinancing-container'>{children}</div>
    </div>
  )
}

interface IRefinancingProps {
  clientData: IRefinancingClient | undefined
  setRefinTitle: (title: string) => void
  callbackProductChooser: () => void
  callbackFunction: (proposalId: string) => void
}

export default function Refinancing ({
  clientData,
  setRefinTitle,
  callbackProductChooser,
  callbackFunction
}: IRefinancingProps) {
  const simulation = useSimulation()
  const dispatch = useDispatch()
  const [selectedContract, setSelectedContract] = useState<IFinishedProposalsToRefinance>()

  useEffect(() => {
    dispatch(simulationSteps(0))
  }, [])

  return (
    <PageContainer>
      <div className='custom-counter'>
        <SimulatorSteps
          counterStep={simulation.step}
          onClick={(value) => value ? dispatch(simulationSteps(value)) : dispatch(simulationSteps(0))}
          quantity={4}
        />
      </div>

      {simulation.step === 0 && (
        <ContractList
          clientData={clientData}
          setRefinTitle={setRefinTitle}
          callbackProductChooser={callbackProductChooser}
          selectedContract={selectedContract}
          setSelectedContract={setSelectedContract}
        />
      )}

      {simulation.step === 1 && <RefinancingData />}

      {simulation.step === 2 && <CustomerData />}

      {simulation.step === 3 && <AddressData />}

      {simulation.step === 4 && <Simulation callbackFunction={callbackFunction} />}
    </PageContainer>
  )
}
